// API response types for Billing Cycles (match proxy GraphQL schema)

/** Billing cycle duration unit. Only DAY and MONTH are supported. */
export type DurationUnit = "DAY" | "MONTH";

export const DURATION_UNITS: DurationUnit[] = ["DAY", "MONTH"];

/** Human-readable label for UI (e.g. "Per day", "Per month"). */
export function formatDurationUnitLabel(unit: DurationUnit): string {
  return unit === "DAY" ? "Per day" : "Per month";
}

export interface BillingCycle {
  billingCycleId: string;
  code: string;
  label: string;
  durationValue: number;
  durationUnit: DurationUnit;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface ListBillingCyclesInput {
  activeOnly?: boolean;
}

export interface ListBillingCyclesResponse {
  listBillingCycles: {
    code: string;
    billingCycleList: BillingCycle[];
  };
}

export interface GetBillingCycleInput {
  billingCycleId: string;
}

export interface GetBillingCycleResponse {
  getBillingCycle: {
    code: string;
    billingCycle: BillingCycle | null;
  };
}

export interface CreateBillingCycleInput {
  code: string;
  label: string;
  durationValue: number;
  durationUnit: DurationUnit;
  isActive?: boolean;
}

export interface CreateBillingCycleResponse {
  createBillingCycle: {
    code: string;
    billingCycle: BillingCycle | null;
  };
}

export interface UpdateBillingCycleInput {
  label?: string;
  durationValue?: number;
  durationUnit?: DurationUnit;
  isActive?: boolean;
}

export interface UpdateBillingCycleResponse {
  updateBillingCycle: {
    code: string;
    billingCycle: BillingCycle | null;
  };
}
